var slice = [].slice;
var eventsKey = "__events";

export default {
    /**
     *
     * @param event
     * @param callback
     * @returns {on}
     */
    on: function(event, callback) {
        var allEvents = this[eventsKey];
        var list;

        if (!allEvents) {
            allEvents = this[eventsKey] = {};
        }

        list = allEvents[event];

        if (!list) {
            list = allEvents[event] = [];
        }

        list.push(callback);
        return this;
    },

    /**
     * Fire an event and pass all additional parameters into the callback.
     * @param {String} event
     */
    trigger: function(event) {
        // no one has registered a callback for this event
        if (!this[eventsKey]) {
            return this;
        }

        var list = this[eventsKey][event];
        var args = slice.call(arguments, 1);

        // there are no event handler
        if (!list || list.length === 0) {
            return this;
        }

        // Add an event object to the callback parameters
        args.unshift({
            type: event,
            eventName: event,
        });

        // copy the list so that it can still be iterated over in the order
        // they were added but if a callback is removed during the loop it wont matter
        list = slice.call(list);

        // The fire loop invoking the callbacks
        for (var i = 0, l = list.length; i < l; i++) {
            list[i].apply(this, args);
        }

        return this;
    },

    /**
     * Removes a callback
     *
     * @param {String} event
     * @param {Function} callback Exact reference to the handler,
     *    needed when you only want to remove one specific listener and not all
     */
    off: function(event, callback) {
        var allEvents = this[eventsKey];

        // no event name passed or no callbacks for this event
        if (!event || !allEvents || !allEvents[event]) {
            return this;
        }

        // removing a specific callback
        var list = allEvents[event];

        for (var i = 0, l = list.length; i < l; i++) {
            if (list[i] === callback) {
                list.splice(i, 1);
                break;
            }
        }

        return this;
    },
};
